module.exports = __webpack_public_path__ + "static/img/topLogo.f64dbbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/topLogo.png
// module id = x6xI
// module chunks = 1